import { Article, ScreenContainer, Button, HeroSection, Hero, HeroBody, HeroTitle, HeroTeaser, HeroActionList, HeroAction, FeatureSection, FeatureList, Feature, FeatureTitle, FeatureText, FeatureImage, SiblingNav, SiblingNavLink } from 'smooth-doc/components';
import heroBackgroundImageURL from "../../../../images/hero-background.png";
import CloudIconImageURL from "../../../../images/icons8-cloud-96.png";
import KubeIconImageURL from "../../../../images/icons8-backend-development-96.png";
import MonitoringIconImageURL from "../../../../images/icons8-inspect-code-96.png";
import TerraformIconImageURL from "../../../../images/icons8-module-96.png";
import CostsIconImageURL from "../../../../images/icons8-receive-euro-96.png";
import AWSIconImageURL from "../../../../images/icons8-amazon-96.png";
import RocketIconImageURL from "../../../../images/icons8-rocket-96.png";
import * as React from 'react';
export default {
  Article,
  ScreenContainer,
  Button,
  HeroSection,
  Hero,
  HeroBody,
  HeroTitle,
  HeroTeaser,
  HeroActionList,
  HeroAction,
  FeatureSection,
  FeatureList,
  Feature,
  FeatureTitle,
  FeatureText,
  FeatureImage,
  SiblingNav,
  SiblingNavLink,
  heroBackgroundImageURL,
  CloudIconImageURL,
  KubeIconImageURL,
  MonitoringIconImageURL,
  TerraformIconImageURL,
  CostsIconImageURL,
  AWSIconImageURL,
  RocketIconImageURL,
  React
};